import { styled, Typography } from '@mui/material';

export const Nav = styled('nav')(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#222' : '#F9FCFF',
  padding: theme.spacing(2, 4),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  borderRadius: theme.spacing(4),
  marginBottom: theme.spacing(2),
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
  fontFamily: "'Poppins', sans-serif",
  fontSize: '16px !important',
  fontWeight: 600,
  lineHeight: 'normal',
  color: theme.palette.primary.main,
  flex: 1,
  textAlign: 'center',
}));

export const AvatarContainer = styled('div')(({ theme }) => ({
  width: theme.spacing(6.5),
  height: theme.spacing(6.5),
  borderRadius: '50%',
  backgroundColor: theme.palette.secondary.main,
  flexShrink: 0,
}));
